function isSelected(name: string): string {
    if (window.location.pathname.indexOf(name) > -1) {
        return 'selected'
    }

    // exception for root route - add a whitelist for other exceptions and where they should be mapped on the main nav
    if (window.location.pathname === '/' && name === 'home') {
        return 'selected';
    }

    return '';
}

function onClick(event: React.MouseEvent<HTMLAnchorElement>): void {
    var nav = document.getElementsByClassName('nav-choices')[0];
    var items = nav.getElementsByTagName('a');
    for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('selected');
    }

    var clickEventTarget = event.target as HTMLAnchorElement;
    if (clickEventTarget != null)
        if (clickEventTarget.className === "nav-logo") {
            //clickEventTarget.classList.add('selected');
        } else if (event != null) {
            clickEventTarget.classList.add('selected');
        }
}

export { isSelected, onClick };